let translations = {
    es: {
        // Terminal
        "Appel bar": "Llama al bar",
        "Assistance": "Asistencia",
        "Faire venir un serveur ?": "¿Llamar a un camarero?",
        "Oui !": "Sí",
        "Non": "No",
        "Réglages": "Ajustes",
        "Mode": "Modo",
        "photosensible": "Fotosensible",
        "accessibilité": "Accesibilidad",
        "Accessibilité": "Accesibilidad",
        "On arrive !": "¡Estamos llegando!",
        "Faire intervenir un membre de notre personnel ?": "¿Llamar a un miembro de nuestro personal?",
        "Retour menu": "Volver al menú",
        "Démarrer": "Iniciar",
        "Session terminée": "Sesión terminada",
        "Dernière chanson !": "¡Última canción!",
        "Guide": "Guía",
        "vocal": "de voz",
        "Auto-tune": "Auto-tune",
        "Micros": "Micrós",
        "Musique": "Música",
        "Rechercher..." : "Buscar...",
        // Categories
        "KIDS": "NIÑOS",
        "FRANÇAIS": "FRANCÉS",
        "RÉCENT": "RECIENTE",
        "DUOS": "DUETOS",
        "FILMS": "PELÍCULAS",
        "ANGLAIS": "INGLÉS",
        "ESPAGNOL": "ESPAÑOL",
        "MUSIQUES DU MONDE": "MÚSICAS DEL MUNDO",
        "ANNÉES 2010": "AÑOS 2010",
        "ANNÉES 2000": "AÑOS 2000",
        "ANNÉES 90": "AÑOS 90",
        "ANNÉES 80": "AÑOS 80",
        "ANNÉES 70": "AÑOS 70",
        // Manage
        "Redémarrer": "Reiniciar",
        "Éteindre": "Apagar",
        "AntalZic vous souhaite la Bienvenue !" : "¡AntalZic te da la bienvenida!",
        "Aucune session" : "Ninguna sesión",
        "Dernière" : "Última",
        "Attente" : "Espera",
        "C'est parti !" : "¡Vamos!",
        "Salle 1" : "Sala 1",
        "Salle 2" : "Sala 2",
        "Salle 3" : "Sala 3",
        "Salle 4" : "Sala 4",
        "Salle 5" : "Sala 5",
        "Salle 6" : "Sala 6",
        "Salle" : "Sala",
    },
    en: {
        "Appel bar": "Call the bar",
        "Assistance": "Assistance",
        "Faire venir un serveur ?": "Call a waiter?",
        "Oui !": "yes",
        "Non": "No",
        "Réglages": "Settings",
        "Mode": "Mode",
        "photosensible": "Photosensitive",
        "accessibilité": "Accessibility",
        "Accessibilité": "Accessibility",
        "On arrive !": "We are coming!",
        "Faire intervenir un membre de notre personnel ?": "Call a member of our staff?",
        "Retour menu": "Back to menu",
        "Démarrer": "Start",
        "Session terminée": "Session ended",
        "Dernière chanson !": "Last song!",
        "Guide": "Voice",
        "vocal": "guide",
        "Auto-tune": "Auto-tune",
        "Micros": "Micros",
        "Musique": "Music",
        "Rechercher..." : "Search...",
        // Categories
        "FRANÇAIS": "FRENCH",
        "RÉCENT": "RECENT",
        "DUOS": "DUETS",
        "FILMS": "MOVIES",
        "ANGLAIS": "ENGLISH",
        "ESPAGNOL": "SPANISH",
        "MUSIQUES DU MONDE": "WORLD MUSIC",
        "ANNÉES 2010": "2010s",
        "ANNÉES 2000": "2000s",
        "ANNÉES 90": "90s",
        "ANNÉES 80": "80s",
        "ANNÉES 70": "70s",
        // Manage
        "Redémarrer": "Restart",
        "Éteindre": "Shutdown",
        "AntalZic vous souhaite la Bienvenue !" : "AntalZic welcomes you!",
        "Aucune session" : "No session",
        "Dernière" : "Last",
        "Attente" : "Waiting",
        "C'est parti !" : "Let's go!",
        "Salle 1" : "Room 1",
        "Salle 2" : "Room 2",
        "Salle 3" : "Room 3",
        "Salle 4" : "Room 4",
        "Salle 5" : "Room 5",
        "Salle 6" : "Room 6",
        "Salle" : "Room",
    }
}

export default translations;
